import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert, Button, Form } from "react-bootstrap";
import { secondsToTime } from "../../utilities/scoringUtilities";
import { MatchEvents } from "../../models/enums/MatchEvents";
import { PenaltyOutcome } from "../../models/enums/PenaltyOutcome";
import { PenaltyReason } from "../../models/enums/PenaltyReason";
import { LineoutTarget } from "../../models/enums/LineoutTarget";
import { FreekickOutcome } from "../../models/enums/FreekickOutcome";
import scoringService from "../../services/ScoringService";

import { v4 as uuidv4 } from "uuid";

const ScrumInfo = (props) => {
  const {
    isWon,
    setIsWon,
    isScrumPenalty,
    setIsScrumPenalty,
    isFreekick,
    setIsFreekick,
  } = props;
  
  const handleWonOrLostStatus = (isWon) => {
    setIsWon(isWon);
  };

  const handleFreekickStatus = (status) => {
    setIsFreekick((prevState) => (prevState === status ? null : status));
  };

  const handlePenaltyStatus = (status) => {
    setIsScrumPenalty((prevState) => (prevState === status ? null : status));
  };

  return (
    <>
      <div className="container">
  <div className="row justify-content-center mt-4">
    <div className="col-md-12 text-center">
      <h5>Outcome</h5>
    </div>
    <div className="col-md-4 col-xs-6 col-sm-6 col-6 text-center mb-3">
      <Button
        className="fixed-size-button"
        variant="outline-secondary"
        style={{
          width: "170px",
          height: "40px",
          backgroundColor: isWon ? "#70747c" : "",
          color: isWon ? "white" : "",
        }}
        onClick={() => handleWonOrLostStatus(true)}
      >
        WON
      </Button>
    </div>
    <div className="col-md-4 col-xs-6 col-sm-6 col-6 text-center mb-3">
      <Button
        className="fixed-size-button"
        variant="outline-secondary"
        style={{
          width: "170px",
          height: "40px",
          backgroundColor:
            isScrumPenalty === PenaltyOutcome.PenaltyFor ? "#70747c" : "",
          color:
            isScrumPenalty === PenaltyOutcome.PenaltyFor ? "white" : "",
        }}
        onClick={() => handlePenaltyStatus(PenaltyOutcome.PenaltyFor)}
      >
        PENALTY FOR
      </Button>
    </div>
    <div className="col-md-4 col-xs-6 col-sm-6 col-6 text-center mb-3">
      <Button
        className="fixed-size-button"
        variant="outline-secondary"
        style={{
          width: "170px",
          height: "40px",
          backgroundColor:
            isFreekick === FreekickOutcome.FreeKickFor ? "#70747c" : "",
          color: isFreekick === FreekickOutcome.FreeKickFor ? "white" : "",
        }}
        onClick={() => handleFreekickStatus(FreekickOutcome.FreeKickFor)}
      >
        FREE KICK FOR
      </Button>
    </div>
    <div className="col-md-4 col-xs-6 col-sm-6 col-6 text-center mb-3">
      <Button
        className="fixed-size-button"
        variant="outline-secondary"
        style={{
          width: "170px",
          height: "40px",
          backgroundColor: isWon === false ? "#70747c" : "",
          color: isWon === false ? "white" : "",
        }}
        onClick={() => handleWonOrLostStatus(false)}
      >
        LOST
      </Button>
    </div>
    <div className="col-md-4 col-xs-6 col-sm-6 col-6 text-center mb-3">
      <Button
        className="fixed-size-button"
        variant="outline-secondary"
        style={{
          width: "170px",
          height: "40px",
          backgroundColor:
          isScrumPenalty === PenaltyOutcome.PenaltyAgainst ? "#70747c" : "",
          color:
          isScrumPenalty === PenaltyOutcome.PenaltyAgainst ? "white" : "",
        }}
        onClick={() => handlePenaltyStatus(PenaltyOutcome.PenaltyAgainst)}
      >
        PENALTY AGAINST
      </Button>
    </div>
    <div className="col-md-4 col-xs-6 col-sm-6 col-6 text-center mb-3">
      <Button
        className="fixed-size-button"
        variant="outline-secondary"
        style={{
          width: "170px",
          height: "40px",
          backgroundColor:
            isFreekick === FreekickOutcome.FreeKickAgainst ? "#70747c" : "",
          color: isFreekick === FreekickOutcome.FreeKickAgainst ? "white" : "",
        }}
        onClick={() => handleFreekickStatus(FreekickOutcome.FreeKickAgainst)}
      >
        FREE KICK AGAINST
      </Button>
    </div>
  </div>
</div>
      </>
  );
};

export default ScrumInfo;
